import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { LandingPage } from './client/components/LandingPage'
import WorkflowPage from './pages/WorkflowPage'
import ProjectDetail from './pages/ProjectDetail'
import ProjectsList from './pages/ProjectsList'
import './client/styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/projects/:projectId" element={<ProjectDetail />} />
        <Route path="/workflow/:workflowId" element={<WorkflowPage />} />
      </Routes>
    </Router>
  </React.StrictMode>,
) 